import { Fragment } from 'react';
import { ApMap, updateApMap } from '../../../../../store/ApMap';
import { DetailPanelParams } from '../../../../Compounds/DetailPanel/DetailPanel';
import { DetailViewCard } from '../../../../Compounds/CardWithTitle';
import { DetailPanelContainer } from '../../../../Compounds/DetailPanel/DetailPanelContainer';
import { EditFieldType } from '../../../../Compounds/DetailPanel/LabelValueField';
import { EntityType } from '../../../../../store/Search';

export interface ApMapDetailsParams {
  data: ApMap;
}

export const apMapSections = (data: ApMap): DetailPanelParams[] => [
  {
    data,
    canEdit: [
      {
        field: 'ap_rpm',
        type: EditFieldType.TEXT
      }
    ],
    fieldMap: {
      ap_name: 'Salesforce AP',
      ap_rpm: 'RPM Agency Group'
    },
    order: ['ap_name', 'ap_rpm'],
    links: [
      {
        field: 'ap_name',
        link: null,
        externalLink: `${process.env.REACT_APP_SALESFORCE_INSTANCE_URL}/lightning/r/Account/${data.ap_sfid}/view`,
        external: true
      }
    ]
  },
  {
    data,
    canEdit: [
      {
        field: 'ap_rpm_rep_id',
        type: EditFieldType.SEARCHBOX,
        mapType: EntityType.RPM_REP
      }
    ],
    fieldMap: {
      ap_rpm_rep_id: 'RPM Rep Assignment'
    },
    associationNameFields: {
      ap_rpm_rep_id: 'ap_rpm_rep_name'
    },
    order: ['ap_rpm_rep_id']
  }
];

export const ApMapDetails = ({ data }: ApMapDetailsParams) => {
  const handleSave = (update: ApMap) => updateApMap(update);

  return (
    <Fragment>
      <div
        className="space-y-4 min-h-[30rem]"
        data-testid="ap-map-details-drawer">
        <DetailViewCard
          enableCollapse
          key="ap-map-detail-card"
          title="Info">
          <div
            data-testid="ap-map-detail-card"
            className="min-h-[12rem]">
            <DetailPanelContainer
              data={apMapSections(data)}
              saveAction={(d) => handleSave(d as ApMap)}
            />
          </div>
        </DetailViewCard>
      </div>
    </Fragment>
  );
};
